import { transformStringToStringArray } from '../transformStringToStringArray';
import { CollaboratorMatcher } from './collaboratorMatcher';

import uniq from 'lodash/uniq';

export const transformStringToCollaboratorArray = ({
  stringValue,
  collaboratorMatcher,
}: {
  stringValue: string;
  collaboratorMatcher: CollaboratorMatcher;
}): string[] | null => {
  const stringArr = uniq(transformStringToStringArray(stringValue));
  const collaboratorIds: string[] = [];
  stringArr.forEach((str) => {
    const matchedCollaborator = collaboratorMatcher.match(str);
    if (matchedCollaborator) {
      collaboratorIds.push(matchedCollaborator.userId);
    }
  });
  return collaboratorIds.length > 0 ? uniq(collaboratorIds) : null;
};
